import PropTypes from 'prop-types';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from 'hooks/useToken';
import ProductosTable from './ProductosTable';
import ResumenTotales from './ResumenTotales';
import ModalEliminarLicencia from './ModalEliminarLicencia';
import ModalAgregarLicencia from './ModalAgregarLicencia';
import useProductosEdicion from '../hooks/useProductosEdicion';
import useLicenciasGestion from '../hooks/useLicenciasGestion';

/**
 * Componente principal para mostrar los detalles de una orden
 * Refactorizado para mejor mantenibilidad y separación de responsabilidades
 */
const SeccionDetallesOrden = ({
    loadingInfoDetallesOrden,
    ordenDetalles,
    orden,
    setOrden,
    GuardarComentario,
    ObtenerDetallesOrden,
    actualizarMonedaLinksPagos,
    onComentarioAgregado,
    tienePagos,
    onPlanAsociado,
    productoTimbres
}) => {
    const { idCatTipoUsuario } = useToken();
    console.log("Renderizando SeccionDetallesOrden con orden:", productoTimbres);

    // Hook para edición de precios y cantidades
    const {
        showEditarPrecios,
        editedProducts,
        editedMoneda,
        guardandoCambios,
        setEditedMoneda,
        inicializarEdicion,
        handleProductChange,
        handleProductBlur,
        cancelarEdicion,
        guardarCambiosPrecios
    } = useProductosEdicion(
        ordenDetalles,
        orden,
        setOrden,
        actualizarMonedaLinksPagos,
        ObtenerDetallesOrden,
        GuardarComentario,
        onComentarioAgregado
    );

    // Hook para gestión de licencias
    const {
        seguroStateEliminar,
        setseguroStateEliminar,
        modalStateAgregarLicencia,
        setModalStateAgregarLicencia,
        licenciasModal,
        selectedLicencia,
        setSelectedLicencia,
        obtenerLicenciasParaModal,
        cancelarLicenciaOrden,
        guardarLicenciaOrdenDetalle
    } = useLicenciasGestion(
        GuardarComentario,
        ObtenerDetallesOrden,
        orden?.idOrden, // Add idOrden
        orden, // Add orden object
        onComentarioAgregado
    );

    return loadingInfoDetallesOrden ? (
        <Skeleton height={300} />
    ) : (
        <>
            <div className="table-responsive fs--1">
                {/* Tabla de productos */}
                <ProductosTable
                    ordenDetalles={ordenDetalles}
                    orden={orden}
                    showEditarPrecios={showEditarPrecios}
                    editedProducts={editedProducts}
                    handleProductChange={handleProductChange}
                    handleProductBlur={handleProductBlur}
                    obtenerLicenciasParaModal={obtenerLicenciasParaModal}
                    setseguroStateEliminar={setseguroStateEliminar}
                    idCatTipoUsuario={idCatTipoUsuario}
                    onPlanAsociado={onPlanAsociado}
                    productoTimbres={productoTimbres}
                />

                {/* Resumen de totales */}
                <ResumenTotales
                    orden={orden}
                    showEditarPrecios={showEditarPrecios}
                    editedProducts={editedProducts}
                    editedMoneda={editedMoneda}
                    setEditedMoneda={setEditedMoneda}
                    inicializarEdicion={inicializarEdicion}
                    guardarCambiosPrecios={guardarCambiosPrecios}
                    cancelarEdicion={cancelarEdicion}
                    guardandoCambios={guardandoCambios}
                    tienePagos={tienePagos}
                />
            </div>

            {/* Modal para confirmar eliminación de licencia */}
            <ModalEliminarLicencia
                seguroStateEliminar={seguroStateEliminar}
                setseguroStateEliminar={setseguroStateEliminar}
                cancelarLicenciaOrden={cancelarLicenciaOrden}
            />

            {/* Modal para agregar licencia */}
            <ModalAgregarLicencia
                modalStateAgregarLicencia={modalStateAgregarLicencia}
                setModalStateAgregarLicencia={setModalStateAgregarLicencia}
                licenciasModal={licenciasModal}
                selectedLicencia={selectedLicencia}
                setSelectedLicencia={setSelectedLicencia}
                guardarLicenciaOrdenDetalle={guardarLicenciaOrdenDetalle}
            />

        </>
    );
};

SeccionDetallesOrden.propTypes = {
    orden: PropTypes.object,
    setOrden: PropTypes.func,
    loadingInfoDetallesOrden: PropTypes.bool,
    ordenDetalles: PropTypes.array,
    GuardarComentario: PropTypes.func,
    ObtenerDetallesOrden: PropTypes.func,
    actualizarMonedaLinksPagos: PropTypes.func,
    onComentarioAgregado: PropTypes.func,
    tienePagos: PropTypes.bool,
    onPlanAsociado: PropTypes.func,
    productoTimbres: PropTypes.number
};

export default SeccionDetallesOrden;
